<template>
  <JoszakiModal
    :open="isOpen"
    :title="$t('mobileExistsModal.title')"
    @cancel="close"
    @close="close"
  >
    <template #body>
      <template v-if="!smsSent">
        <p class="text-xl text-left md:text-center">
          {{ $t("mobileExistsModal.thisNumber") }}
        </p>
        <p class="text-3xl bg-whitesmoke text-center align-middle py-4">
          {{ $helpers.formatPhoneNumber(phone) }}
        </p>
        <p class="text-xl text-left md:text-center">
          {{ $t("mobileExistsModal.alreadyRegistered") }}
        </p>
        <p>
          {{ $t("mobileExistsModal.loginOrResetPassword") }}
        </p>
      </template>
      <template v-else>
        <JoszakiMessage type="success">
          <div class="flex gap-2 items-center">
            <IconComponent icon="paper-plane" />
            {{ $t("mobileExistsModal.sms.success") }}
          </div>
        </JoszakiMessage>

        <p class="text-xl">
          {{ $t("mobileExistsModal.sms.instructions") }}
        </p>
      </template>
    </template>

    <template #footer>
      <div v-if="!smsSent" class="w-full flex justify-between">
        <JoszakiButton type="info" :inverted="true" @click="sendSms"
          ><span class="font-bold">{{
            $t("mobileExistsModal.sms.sendAction")
          }}</span></JoszakiButton
        >
        <JoszakiButton type="success" :to="localePath({ name: 'login' })">
          {{ $t("mobileExistsModal.login") }}
        </JoszakiButton>
      </div>
      <div v-else class="flex-1 flex justify-end">
        <JoszakiButton type="success" @click="close">
          {{ $t("common.close") }}
        </JoszakiButton>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import { ref, useContext } from "@nuxtjs/composition-api";
import { useRegistration } from "./useRegistration";
import RECOVER_PASSWORD_BY_PHONE_NUMBER from "./recoverPasswordByPhoneNumber.graphql";

export default {
  setup() {
    const { $sentry, $mutate, $joszaki, i18n } = useContext();
    const { phone } = useRegistration();
    const isOpen = ref(false);
    const smsSent = ref(false);
    const sendingSms = ref(false);
    const error = ref(false);

    const open = () => {
      isOpen.value = true;
    };

    const close = () => {
      isOpen.value = false;
      smsSent.value = false;
      sendingSms.value = false;
      error.value = false;
    };

    async function sendSms() {
      try {
        sendingSms.value = true;
        await $mutate(RECOVER_PASSWORD_BY_PHONE_NUMBER, {
          phoneNumber: phone.value.number,
          countryCodeId: phone.value.countryCode.id,
        });
        error.value = false;
        smsSent.value = true;
      } catch (error) {
        error.value = true;
        console.error(error);
        $sentry.captureException(error, {
          tags: {
            component: "MobileExistsModal",
            action: "sendSms",
          },
        });
        $joszaki.toast({
          type: "error",
          message: i18n.t("error.unknown"),
        });
      } finally {
        sendingSms.value = false;
      }
    }

    return {
      isOpen,
      open,
      phone,
      smsSent,
      sendingSms,
      error,
      sendSms,
      close,
    };
  },
};
</script>
